module.exports = __webpack_public_path__ + "img/dialog-bg.de266ea1.png";